module.exports = __webpack_public_path__ + "static/media/youtube-symbol.01ede660.svg";